const HIERARCHY_RULES = Object.freeze([
  { key: 'updatedRows', layer: 'CML Records', icon: 'mdi-pencil-outline', iconColor: 'info', action: 'Updated existing records', countClass: 'info--text', statusText: 'Applied', statusType: 'success' },
  { key: 'mergedRows', layer: 'CML Records', icon: 'mdi-merge', iconColor: 'primary', action: 'Merged duplicate source rows', countClass: 'primary--text', statusText: 'Merged', statusType: 'success' },
  { key: 'newRows', layer: 'CML Records', icon: 'mdi-plus-circle-outline', iconColor: 'success', action: 'Created new records', countClass: 'success--text', statusText: 'Created', statusType: 'success' },
  { key: 'restoredRows', layer: 'CML Records', icon: 'mdi-restore', iconColor: 'light-green', action: 'Restored deleted records', countClass: 'light-green--text', statusText: 'Restored', statusType: 'success' },
  { key: 'tmlPointsMatched', layer: 'TML Points', icon: 'mdi-target-variant', iconColor: 'teal', action: 'Matched existing measurement points', countClass: 'teal--text', statusText: 'Linked', statusType: 'success' },
  { key: 'tmlPointsUpserted', layer: 'TML Points', icon: 'mdi-crosshairs-gps', iconColor: 'teal', action: 'Created measurement points', countClass: 'teal--text', statusText: 'Created', statusType: 'success' },
  { key: 'readingsInserted', layer: 'Thickness Readings', icon: 'mdi-database-plus-outline', iconColor: 'cyan', action: 'Inserted historical readings', countClass: 'cyan--text', statusText: 'Inserted', statusType: 'success' },
  { key: 'readingsLinked', layer: 'Thickness Readings', icon: 'mdi-link-variant', iconColor: 'indigo', action: 'Linked readings to inspections', countClass: 'indigo--text', statusText: 'Linked', statusType: 'success' },
  { key: 'inspectionsCreated', layer: 'Inspections', icon: 'mdi-clipboard-plus-outline', iconColor: 'deep-purple', action: 'Created missing inspection tags', countClass: 'deep-purple--text', statusText: 'Created', statusType: 'success' },
  { key: 'readingsRelinked', layer: 'Thickness Readings', icon: 'mdi-link-plus', iconColor: 'purple', action: 'Relinked readings to inspections', countClass: 'purple--text', statusText: 'Relinked', statusType: 'success' },
  { key: 'readingsSkipped', layer: 'Thickness Readings', icon: 'mdi-skip-forward-outline', iconColor: 'blue-grey', action: 'Skipped existing reading dates', countClass: 'blue-grey--text', statusText: 'Skipped', statusType: 'warning' },
  { key: 'readingsFailed', layer: 'Thickness Readings', icon: 'mdi-close-circle-outline', iconColor: 'error', action: 'Failed to persist readings', countClass: 'error--text', statusText: 'Failed', statusType: 'error' },
  { key: 'failedRows', layer: 'CML Records', icon: 'mdi-alert-circle-outline', iconColor: 'error', action: 'Rejected invalid rows', countClass: 'error--text', statusText: 'Failed', statusType: 'error' },
  { key: 'skippedRows', layer: 'CML Records', icon: 'mdi-minus-circle-outline', iconColor: 'grey', action: 'Skipped empty rows', countClass: 'grey--text', statusText: 'Skipped', statusType: 'neutral' },
]);

function rowLabel(rowIndex) {
  return Number.isInteger(rowIndex) && rowIndex >= 0 ? `Row ${rowIndex}` : 'Import';
}

function warningPresentation(message) {
  const normalized = String(message || '').toLowerCase();
  if (normalized.includes('reading')) {
    return { category: 'Reading', action: normalized.includes('skip') ? 'Skipped' : 'Review' };
  }
  if (normalized.includes('inspection')) {
    return { category: 'Inspection', action: 'Review' };
  }
  return { category: 'Warning', action: 'Review' };
}

function errorIssue(error, index) {
  return {
    id: `error-${index}`,
    rowLabel: rowLabel(error.rowIndex),
    category: 'Validation',
    message: (error.validationErrors || []).join('; ') || 'Row failed validation',
    statusType: 'error',
    action: error.wasSkipped ? 'Skipped' : 'Rejected',
    rowData: error.rowData || null,
  };
}

function warningIssue(warning, index) {
  return {
    id: `warning-${index}`,
    rowLabel: rowLabel(warning.rowIndex),
    message: warning.message || 'The import completed with a warning.',
    statusType: 'warning',
    rowData: null,
    ...warningPresentation(warning.message),
  };
}

export function buildHierarchyRows(statistics = {}) {
  return HIERARCHY_RULES.flatMap(({ key, ...presentation }) => {
    const count = Number(statistics[key]) || 0;
    return count > 0 ? [{ ...presentation, count }] : [];
  });
}

export function countAppliedCmlRows(statistics = {}) {
  return ['newRows', 'updatedRows', 'mergedRows', 'restoredRows']
    .reduce((total, key) => total + (Number(statistics[key]) || 0), 0);
}

export function buildItemizedIssues(errors = [], warnings = []) {
  return [
    ...errors.map(errorIssue),
    ...warnings.map(warningIssue),
  ];
}
